import { render, staticRenderFns } from "./EmailTemplateList.vue?vue&type=template&id=112428d6"
import script from "./EmailTemplateList.vue?vue&type=script&lang=js"
export * from "./EmailTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports